// used for DataQuality page
export const calculateTotalValidityData= (data) => {   
  const currentData = data.reduce((acc, curr) => {
    acc.totalRecords += Number(curr.totalRecords) || 0;
    acc.totalRecordsValidationFailed += Number(curr.validationFailedCount) || 0;
    acc.totalRecordsConfirmed += Number(curr.confirmedCount) || 0;
    acc.totalRecordsValidated += Number(curr.validatedCount) || 0;
    acc.totalValidationRules += Number(curr.validationRulesCount) || 0;
    return acc;
  }, 
  {
    totalRecords: 0,
    totalRecordsValidationFailed: 0,
    totalRecordsConfirmed: 0,
    totalRecordsValidated: 0,
    totalValidationRules: 0,
  });
  return currentData;
};